import React from 'react';
import Tags from '~/components/InlineEditFields/Tags';
import useFaqPostTags from '~/hooks/tags/useFaqPostTags';
export const FaqPostTags = (props) => {
    const { faqPostRef } = props;
    const { data: userTags, setTagsLoading, setFaqPostTags } = useFaqPostTags(faqPostRef);
    return <Tags tags={userTags} setTagsLoading={setTagsLoading} setTags={setFaqPostTags}/>;
};
export default FaqPostTags;
